module.exports = __webpack_public_path__ + "img/logo.26771d48.png";